import React from 'react';
import { Skeleton } from '../../../../../components/ComponentsV1/Skeleton/Skeleton';
import { SKELETON_ROWS } from '../constants';

const IvaSkeleton = () => (
  <div className='tw-bg-white tw-p-8 tw-rounded-2xl'>
    <Skeleton rows={SKELETON_ROWS} />
  </div>
);

export default IvaSkeleton;
